export const ASSETS = "/varad";
export const BUILDINGS = "/hooned";
export const STRUCTURES = "/rajatised";
export const CADASTRALUNITS = "/katastriüksused";
export const BULKEDIT = "/mass-muutmine";
export const ERROR = "/viga";

export const PROCEEDINGS = "/menetlused";
export const CONTRACTS = "/lepingud";
export const CONTRACTS_WORKSPACES = "/valim";

export const REPORTS = "/aruanded";
export const BALANCE = "/bilanss";
export const SUMMARY = "/koondaruanne";
export const ENERGYEFFICIENCY = "/energiatohusus";
export const OPENDATA = "/avaandmed";
export const REALESTATEUNIT = "/kinnisvarauksus";
export const UNIT_MANAGEMENT = "/juhtimiskava";
export const UNIT_MANAGEMENT_BULKEDIT = "/juhtimiskava-mass-muutmine";
export const INVESTMENT_PROJECT_SEARCH = "/investeeringud";
export const INVESTMENT_PROJECT_BULKEDIT = "/investeeringute-mass-muutmine";

export const ADMINISTRATION = "/administreerimine";

export const ORGANISATIONS = "/organisatsioonid";
export const USERS = "/kasutajad";
export const NOTIFICATIONS = "/teated";
export const LISTS = "/loendite-haldus";

export const LIST = "/loend";

export const VAT_MANAGEMENT = "/kaibemaks";
export const THI_MANAGEMENT = "/thi";

export const NOTIFICATIONSSUBSCRIPTIONS = "/teavituste-tellimine";

export const MISSING_USER = "account-does-not-exist";
